var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout-mobile" },
    [
      _vm.Config.STANDALONE ? _c("asta-drawer-standalone") : _c("asta-drawer"),
      _vm._v(" "),
      _c("asta-nav"),
      _vm._v(" "),
      _c(
        "v-main",
        [
          _c(
            "v-dialog",
            {
              attrs: {
                eager: "",
                "max-width": "450",
                "content-class": "asta-svincolati-mobile-dialog",
              },
              model: {
                value: _vm.svincolatiDrawer,
                callback: function ($$v) {
                  _vm.svincolatiDrawer = $$v
                },
                expression: "svincolatiDrawer",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { staticClass: "secondary white--text" },
                    [
                      _c("span", { staticClass: "font-hemi-head" }, [
                        _vm._v("SVINCOLATI"),
                      ]),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: { click: _vm.toggleSvincolati },
                        },
                        [
                          _c("v-icon", { staticClass: "white--text" }, [
                            _vm._v("close"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("asta-svincolati", { staticClass: "navy darken-1" }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "asta-tavolo-mobile" },
            [_c("asta-tavolo")],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "asta-chat-messages-mobile" },
            [_c("asta-chat-messages")],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: {
                eager: "",
                persistent: "",
                "max-width": "450",
                "content-class": "asta-rose-mobile-dialog",
              },
              model: {
                value: _vm.roseOrPlanDrawer,
                callback: function ($$v) {
                  _vm.roseOrPlanDrawer = $$v
                },
                expression: "roseOrPlanDrawer",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { staticClass: "secondary white--text" },
                    [
                      _vm.planOrRose == "plan"
                        ? _c("span", { staticClass: "font-hemi-head" }, [
                            _vm._v("PIANIFICAZIONE"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.planOrRose == "rose"
                        ? _c("span", { staticClass: "font-hemi-head" }, [
                            _vm._v("ROSE"),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        { attrs: { icon: "" }, on: { click: _vm.toggleRose } },
                        [
                          _c("v-icon", { staticClass: "white--text" }, [
                            _vm._v("close"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("asta-rose", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.planOrRose == "rose",
                        expression: "planOrRose == 'rose'",
                      },
                    ],
                    staticClass: "navy darken-1",
                    attrs: { showTitle: "" },
                  }),
                  _vm._v(" "),
                  _vm.my_squadra
                    ? _c("asta-plan", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.planOrRose == "plan",
                            expression: "planOrRose == 'plan'",
                          },
                        ],
                        staticClass: "navy darken-1",
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "asta-chat-input-mobile" },
            [_c("asta-chat-input")],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: {
                color: "gradient-green",
                absolute: "",
                bottom: "",
                left: "",
                fab: "",
              },
              on: { click: _vm.toggleSvincolati },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-column justify-center align-center white--text",
                },
                [
                  _c("v-icon", [_vm._v("groups ")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-caption" }, [_vm._v("Svinc")]),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: {
                color: "gradient-green",
                fab: "",
                absolute: "",
                bottom: "",
                right: "",
              },
              on: { click: _vm.toggleRose },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-column justify-center align-center white--text",
                },
                [
                  _c("div", { staticClass: "text-caption" }, [
                    _vm._v("Rose /"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-caption" }, [
                    _vm._v("Pianif."),
                  ]),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("asta-footer", { attrs: { fixed: "", paddedTop: "" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }